import store from '@/store';
import storage from 'store';

import { APP_LANGUAGE } from '@/store/mutation-types';

export default function Initializer() {
  store.commit('SET_TOKEN', storage.get('access_token'));
  store.commit('SET_ROLES', storage.get('roles'));
  store.commit('SET_USERTYPE', storage.get('userType'));
  store.commit('SET_INFO', storage.get('info'));
  store.commit('SET_CLIENTDATA', storage.get('clientdata'));

  store.dispatch('setLang', storage.get(APP_LANGUAGE, 'vi'));
}



// WEBPACK FOOTER //
// ./src/core/index.js